import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from "../../_base/BaseSubMaintenanceController";
import { PartnerSettingItemMaintenanceDto } from "./PartnerSettingItemMaintenanceDto";
import { PartnerSettingListMaintenanceDto } from "./PartnerSettingListMaintenanceDto";
import { Observable } from 'rxjs-compat';


@Injectable()
export class PartnerSettingSubMaintenanceController extends BaseSubMaintenanceController<PartnerSettingListMaintenanceDto, PartnerSettingItemMaintenanceDto> {
    private base = '/partner/partnersetting'

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "partner/partnersetting");
    }

    public getResourceRoot(): string {
        return "PARTNERSETTING";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/partner/all/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}